import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Fragment } from 'react';
import GlobalStyle from './GlobalStyles';
import { MetaTags } from './components/MetaTags';
import { Homepage } from './pages/Homepage';
import { TermsOfUse } from './pages/TermsOfUse';
import { Privacy } from './pages/Privacy';
import { IntegrityPolicy } from './pages/IntegrityPolicy';
import { Cookies } from './pages/Cookies';

function App() {
  return (
    <Fragment>
      <GlobalStyle />
      <MetaTags />
      <Router>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/integrity-policy" element={<IntegrityPolicy />} />
          <Route path="/cookies" element={<Cookies />} />
        </Routes>
      </Router>
    </Fragment>
  );
}

export default App;
